module.exports = __webpack_public_path__ + "teqbahn-assets/media/22.d4eb5cea.jpg";